import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=6d88aa82&scoped=true&lang=pug"
import script from "./alert.vue?vue&type=script&lang=ts"
export * from "./alert.vue?vue&type=script&lang=ts"
import style0 from "./alert.vue?vue&type=style&index=0&id=6d88aa82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88aa82",
  null
  
)

export default component.exports